import { render } from "./Language.vue?vue&type=template&id=32e64b1e"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"
script.render = render

export default script